'use client';

import PropTypes from 'prop-types';
import { createContext, useMemo, useReducer } from 'react';

export const StaticTextContext = createContext({});

const stateReducer = (state, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const StaticTextProvider = ({ children, value }) => {
  const [state] = useReducer(
    stateReducer,
    {
      texts: value,
    },
    () => ({
      texts: value,
    }),
  );

  const contextValue = useMemo(
    () => ({
      state,
      st: (key) => state?.texts?.[key] || key,
    }),
    [state],
  );

  return (
    <StaticTextContext.Provider value={contextValue}>
      {children}
    </StaticTextContext.Provider>
  );
};

StaticTextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StaticTextProvider;
